import { render, staticRenderFns } from "./ThemeChanger.vue?vue&type=template&id=49c4d86a&"
import script from "./ThemeChanger.vue?vue&type=script&lang=js&"
export * from "./ThemeChanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports